import { IPresence } from '@dxp/core/models';
import { AgentState, AvatarPresence, AvatarPresences } from '@dxp/core/types';
import { differenceInSeconds } from 'date-fns';

export const calculateUserPresence = (
    state: AgentState,
    stateSince: Date,
    breakName?: string,
    timedBreakExpiresAt?: Date,
    pendingState?: AgentState,
    pendingBreakName?: string,
): IPresence => {
    return {
        state: state,
        stateSince: stateSince,
        stateDuration: Math.round(differenceInSeconds(new Date(), stateSince)),
        label: stateToLabel(state, breakName),
        class: stateToClass(state),
        online: stateToOnline(state),
        timedBreakExpiresAt: timedBreakExpiresAt,
        timedBreakRemainingDuration: timedBreakExpiresAt
            ? Math.max(
                  0,
                  Math.round(
                      differenceInSeconds(timedBreakExpiresAt, new Date()),
                  ),
              )
            : undefined,
        pendingState:
            (pendingState ?? state === 'PendingBreak') ? 'Break' : undefined,
        pendingStateLabel: pendingState
            ? stateToLabel(pendingState)
            : state === 'PendingBreak'
              ? stateToLabel('Break', breakName)
              : undefined,
        pendingBreakName:
            (pendingBreakName ?? state === 'PendingBreak')
                ? breakName
                : undefined,
    };
};

const stateToClass = (state: AgentState): AvatarPresence => {
    switch (state) {
        case 'Break':
        case 'PendingBreak':
            return AvatarPresences.Break;
        case 'Idle':
            return AvatarPresences.Idle;
        case 'Busy':
            return AvatarPresences.Busy;
        case 'LoggedOut':
        case 'PendingLogout':
            return AvatarPresences.LoggedOut;
    }
};

const stateToLabel = (state: AgentState, breakName?: string): string => {
    switch (state) {
        case 'LoggedOut':
            return 'Logged out';
        case 'Idle':
            return 'Available';
        case 'Break':
            return breakName || 'Break';
        case 'PendingBreak':
            return 'Pending Break';
        case 'PendingLogout':
            return 'Pending Logout';
        default:
            return state;
    }
};

const stateToOnline = (state: AgentState): boolean => {
    return state !== 'LoggedOut' && state !== 'PendingLogout';
};
